import React, { useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import CloseBtn from "../../images/closeBtn.svg";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
import moment from 'moment';
import { dateFormater } from "../../utils/util";


function EventModal(props) {
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  function closeModal() {
    props.hide(props);
  }

console.log("props",props.onBookTickets)
  return (
    <div>
      <>
        <Transition appear show as={Fragment}>
          <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-lg min-h-[300px] transform overflow-hidden rounded-xl bg-[#2E2842] p-6 text-left align-middle shadow-xl transition-all relative food-modal">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="modalBar mx-auto"></div>
                      <button onClick={closeModal} className="mt-2">
                        <img src={CloseBtn} alt="" />
                      </button>
                      {props.image !==
                        "https://d14p8sk00pvtaq.cloudfront.net/" &&
                        props.image !==
                        "https://d1vpaplb4dywbc.cloudfront.net/" && (
                          <div className="mt-4">
                            <img
                              className="w-full h-[161px] sm:h-[230px] object-cover bg-contain rounded"
                              src={props.image}
                              alt=""
                            />
                          </div>
                        )}
                      <div
                        className={
                          props.image !==
                            "https://d14p8sk00pvtaq.cloudfront.net/" &&
                            props.image !==
                            "https://d1vpaplb4dywbc.cloudfront.net/"
                            ? "mt-2"
                            : "mt-0"
                        }
                      >
                        <div className="modalService mt-3 uppercase">{props.Name}</div>
                        <div className="modalRate mt-2">
                          Event Date -
                          <span className="text-[11px] ml-2 mr-2">
                            {dateFormater(props.Date)}
                          </span>
                          to
                          <span className="text-[11px] ml-2">
                            {dateFormater(props.to)}
                          </span>
                        </div>
                        {props.description ? 
                        <div className="mt-3">
                          <p className="text-[white] text-[13px] ">Description</p>
                        <p className="modalDes ">{props.description}</p>
                        </div>
                        : " "}
                        {props.highlights ? 
                        <div className="mt-3">
                          <p className="text-[white] text-[13px] ">Highlights</p>
                        <p className=" text-[white] text-[13px] font-normal leading-6">{props.highlights}</p>
                        </div>
                       : " " }
                      </div>
                      <button
                        onClick={props.onBookTickets}
                        className="bookBtn mt-4"
                      >
                        Book Tickets
                      </button>
                    </Dialog.Title>
                    <div className="mt-2  w-full flex justify-end items-center confirm-order">
                      <div className="flex items-center gap-3"></div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </>
    </div>
  );
}

export default EventModal;
